(function ($) {
  const initializeBlock = function ($block) {
    function matchHeightFire() {
      $block
        .find(".stat-card--default .stat-card__stat")
        .matchHeight({ property: "min-height" });
      $block
        .find(".stat-card--default .stat-card__icon")
        .matchHeight({ property: "min-height" });
      $block
        .find(".stat-card--default .stat-card__text")
        .matchHeight({ property: "min-height" });
    }

    matchHeightFire();

    $(window).bind("resize orientationchange", function () {
      matchHeightFire();
    });

    setTimeout(function () {
      matchHeightFire();
    }, 1000);

    const $carousel = $block.find(".stat-cards");
    if($carousel.hasClass('slick-initialized'))
      $carousel.slick('unslick');
    $carousel.slick({
      prevArrow: $block.find(".stat-cards-arrow--prev"),
      nextArrow: $block.find(".stat-cards-arrow--next"),
      arrows: true,
      dots: false,
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipe: true,
      adaptiveHeight: false,
      autoplay: true,
      autoplaySpeed: 8000,
      responsive: [
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            swipe: true,
            adaptiveHeight: false,
            autoplay: true,
            autoplaySpeed: 8000,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            swipe: true,
            adaptiveHeight: false,
            autoplay: true,
            autoplaySpeed: 8000,
          },
        },
      ],
    });
  };

  $(document).ready(function () {
    $(".block--stat-cards").each(function () {
      initializeBlock($(this));
    });
  });

  if (window.acf) {
    window.acf.addAction(
      "render_block_preview/type=stat-cards",
      initializeBlock
    );
  }
})(jQuery);
